import apiClient from './client';
import type { Intermediario, IntermediarioList } from '../types/intermediario';

export interface IntermediariFilters {
  page?: number;
  limit?: number;
  search?: string;
}

export interface IntermediarioCreatePayload {
  ragione_sociale: string;
  numero_iscrizione_anga: string;
  data_rilascio: string;
  categorie_classe: string;
  piva?: string | null;
  referente?: string | null;
  contatti?: string | null;
}

export type IntermediarioUpdatePayload = Partial<IntermediarioCreatePayload>;

export async function listIntermediari(filters?: IntermediariFilters): Promise<IntermediarioList> {
  const params: Record<string, string> = {};
  if (filters?.page != null) params['page'] = String(filters.page);
  if (filters?.limit != null) params['limit'] = String(filters.limit);
  if (filters?.search) params['search'] = filters.search;
  const { data } = await apiClient.get<IntermediarioList>('/api/intermediari', { params });
  return data;
}

export async function getIntermediario(id: string): Promise<Intermediario> {
  const { data } = await apiClient.get<Intermediario>(`/api/intermediari/${id}`);
  return data;
}

export async function createIntermediario(payload: IntermediarioCreatePayload): Promise<Intermediario> {
  const { data } = await apiClient.post<Intermediario>('/api/intermediari', payload);
  return data;
}

export async function updateIntermediario(id: string, payload: IntermediarioUpdatePayload): Promise<Intermediario> {
  const { data } = await apiClient.patch<Intermediario>(`/api/intermediari/${id}`, payload);
  return data;
}

export async function deleteIntermediario(id: string): Promise<void> {
  await apiClient.delete(`/api/intermediari/${id}`);
}
